import React, { useState } from "react";
import ManagerDashboardWapper from "../../../../layout/wrapper/ManagerDashboardWapper";
import ManagerSubmittedVideoTabPanel from "../../../../components/ManagerSubmittedVideoTabPanel/ManagerSubmittedVideoTabPanel";
import { Paper } from "@mui/material";
import ManagerPendingVideoTable from "../../../../components/ManagerPendingVideoTable/ManagerPendingVideoTable";
import styles from "../../../../styles/pages/user/managerdashboard/manager-dashboard-pendingvdo.module.scss";
import ManagerPendingvdoDataCalender from "../../../../components/DataCalender/ManagerPendingvdoDataCalender";
import { DateFilterRangeList } from "../../../../hooks/useCalenderFilter";
import { usePost } from "../../../../hooks/api/useFetch";

export default function Pending() {
    const [calanderDate, setCalenderDate] = useState({ from: "", to: "" });
    const [dateFilter, setDateFilter] = useState({
        from: "",
        to: "",
    });
    const handleDateFilter = (dates) => {
        const { startDate, endDate } = dates;
        setDateFilter({ from: startDate, to: endDate });
    };
    const [videoCountry, setVideoCountry] = useState("");
    const [filterParams, setFilterParams] = useState(null);
    const resetFilterparams = () => {
        setFilterParams(null);
        setDateFilter({
            from: "",
            to: "",
        });
        setVideoCountry("");
    };
    const [page, setPage] = useState(1);
    const handlePageChange = (e) => {
        setPage(e);
    };
    const {
        data: managerVideos,
        isSuccess: managerVideosIsSuccess,
        isLoading: managerVideosIsLoading,
        isError: managerVideosIsError,
        refetch: managerVideosRefetch,
    } = usePost(
        [
            "manager-pending-videos",
            filterParams,
            calanderDate,
            dateFilter,
            videoCountry,
            page,
        ],
        "/manager/videos",
        {
            from: dateFilter?.from ? dateFilter?.from : calanderDate?.from,
            to: dateFilter?.to ? dateFilter?.to : calanderDate?.to,
            type: "pending",
            location: videoCountry,
            ...filterParams,
            page: page,
        }
    );
    return (
        <ManagerDashboardWapper>
            <ManagerSubmittedVideoTabPanel />
            <Paper elevation={0} className={styles.tablePaper}>
                <ManagerPendingvdoDataCalender
                    totalVideos={managerVideos?.data?.total}
                    currentFilterParams={filterParams}
                    videoCountry={videoCountry}
                    setVideoCountry={setVideoCountry}
                    dateFilter={dateFilter}
                    handleDateFilter={handleDateFilter}
                    handleFilter={setFilterParams}
                    setCalenderDate={setCalenderDate}
                />
                <ManagerPendingVideoTable
                    managerVideos={managerVideos}
                    managerVideosIsSuccess={managerVideosIsSuccess}
                    managerVideosIsLoading={managerVideosIsLoading}
                    handlePageChange={handlePageChange}
                    resetFilterparams={resetFilterparams}
                    filterParams={filterParams}
                    videoCountry={videoCountry}
                    calanderDate={calanderDate}
                />
            </Paper>
        </ManagerDashboardWapper>
    );
}
